import React, { FC } from 'react';
import { TaskType } from 'api/tasks';
import { ReactComponent as MilestoneIcon } from 'assets/svgs/milestone.svg';
import { ReactComponent as NoStatusIcon } from 'assets/svgs/no-status.svg';
import { Color } from 'components/colors';

export const StatusProposed: FC<{
  type: TaskType;
  color?: Color;
}> = ({ type, color }) => {
  const _color = `var(--ozone-${color || 'blue'}-background)`;

  return type === TaskType.Milestone ? (
    <MilestoneIcon color={_color} />
  ) : (
    <NoStatusIcon color={_color} />
  );
};
